export default {"src":"/_next/static/media/site-preview.d07bc26d.gif","height":630,"width":1200};